import React from "react";
import { Save, Copy, Download, RefreshCw } from "lucide-react";
import type { GeneratedSlides, ColorScheme } from "../types";
import { getSlideColor, getSlideBgColor } from "../utils";
import { EXPORT_FORMATS } from "../constants";

interface ActionButtonsProps {
  generatedSlides: GeneratedSlides;
  colorScheme: ColorScheme;
  onSave?: () => void;
  onCopy?: () => void;
  onDownload?: (format: string) => void;
  onRegenerate?: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  colorScheme,
  onSave,
  onCopy,
  onDownload,
  onRegenerate,
}) => {
  const primaryColor = getSlideColor(colorScheme);
  const bgColor = getSlideBgColor(colorScheme);

  return (
    <div className="border-t border-(--border-color) pt-6">
      <div className="flex flex-wrap gap-3">
        <button
          onClick={onSave}
          className="flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition hover:shadow-md"
          style={{ backgroundColor: bgColor, color: primaryColor }}
        >
          <Save className="w-4 h-4" />
          Salvar Apresentação
        </button>

        <button
          onClick={onCopy}
          className="flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition hover:shadow-md bg-yellow-50 text-yellow-700 dark:bg-yellow-900/20 dark:text-yellow-400"
        >
          <Copy className="w-4 h-4" />
          Copiar Conteúdo
        </button>

        <div className="relative group">
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition hover:shadow-md bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400">
            <Download className="w-4 h-4" />
            Exportar
          </button>
          <div className="absolute top-full left-0 mt-1 w-40 bg-(--card-bg) border border-(--border-color) rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10">
            {EXPORT_FORMATS.map((format) => (
              <button
                key={format}
                onClick={() => onDownload?.(format)}
                className="w-full px-4 py-2 text-sm hover:bg-(--bg-accent) transition text-left text-(--text-primary)"
              >
                Download como {format}
              </button>
            ))}
          </div>
        </div>

        <button
          onClick={onRegenerate}
          className="flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition hover:shadow-md ml-auto bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-400"
        >
          <RefreshCw className="w-4 h-4" />
          Gerar Novamente
        </button>
      </div>
    </div>
  );
};
